/**
 * 网络请求模块
 */
import { post,get, postUrl,uploadFile } from "./ApiHelper";
import * as Enums from '../constant/Enums';

/*****************************************************************  系统基础  *****************************************************************************/
/** 连接token */
export const getClientToken = (success, fail) => {
  return post(
    "/common/getConnectToken",
    success,
    fail
  );
};
/** 用户登录 */
export const login = (userName = "", password = "",verificationCode = "", success, fail) => {
  return postUrl(
    {
      mobile: userName,
      passwd: password,
      verificationCode: verificationCode
    },
    "/manager/jxljhs/login/login",
    success,
    fail
  );
};


/** 通过角色编号查询权限列表 */
export const queryPermissionList = (roleId = "", success, fail) => {
  return postUrl(
    {
      roleId: roleId
    },
    "/manager/jxljhs/role/menu/list",
    success,
    fail
  );
};

/** 查询用户列表 */
export const queryUserList = (
  params,
  success,
  fail
) => {
  return postUrl(
    params,
    "/manager/jxljhs/manageUser/querymore",
    success,
    fail
  );
};

/**查询所有的用户**/
export const queryAllUser = (success, fail) => {
  return postUrl({}, "/manager/user/queryUserListWithPage", success, fail);
};

/** 查询当前用户所在的机构**/
export const queryCurrtUserOfDepartList = (success, fail) => {
  let param = {};
  return postUrl(param, "/manager/jxljhs/organ/tree", success, fail);
};

/** 查看用户详情 */
export const userDetail = (params,success, fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/manageUser/detail",
    success,
    fail
  );
};

/** 查询角色列表 */
export const queryRoleList = (success, fail) => {
  return postUrl(
    {
      pageNum: 1,
      pageSize: 100
    },
    "/manager/jxljhs/manageRole/querymore",
    success,
    fail
  );
};

/** 新增用户 */
export const addUser = (userInfo, success, fail) => {
  return postUrl(userInfo, "/manager/jxljhs/manageUser/save", success, fail);
};
/** 导入用户 */
export const ImportUser = (formData, success, fail) => {
  // return postUrl(params, "/common/uploadExcelFile", success, fail);
  return uploadFile(formData, "/common/uploadExcelFile", success, fail);
};
/** 导出用户列表 */
export const exportUserList = (params) => {
  let query = "?"
  for(let key in params) {
    query += `${key}=${params[key]}&`
  }
  console.log(query)
  window.open(process.env.API_HOST + "/manager/jxljhs/manageUser/exportUserList" + query)
};

/** 重置用户二维码 */
export const modifyQrPics = (params,success,fail) => {
  return postUrl(params,"/manager/jxljhs/manageUser/modifyQrPics",success,fail);
};

/** 修改用户 */
export const updateUser = (userInfo, success, fail) => {
  return postUrl(userInfo, "/manager/jxljhs/manageUser/save", success, fail);
};

/** 重置用户密码 */
export const resetUserPassword = (userId = "", success, fail) => {
  return postUrl(
    {
      newPassword: "123456",
      userId: userId
    },
    "/manager/jxljhs/manageUser/resetting",
    success,
    fail
  );
};

/** 修改个人密码 */
export const resetUserPasswordBySelf = (
  oldPassword = "",
  newPassword = "",
  confirmPassword = "",
  success,
  fail
) => {
  return postUrl(
    {
      oldPassword: oldPassword,
      password: newPassword,
      rnewPassword: confirmPassword
    },
    "/manager/jxljhs/manageUser/modifyPassword",
    success,
    fail
  );
};

/** 删除用户 */
export const deleteUser = (nbrs = "", success, fail) => {
  return postUrl(
    {
      userIds: nbrs
    },
    "/manager/jxljhs/manageUser/delete",
    success,
    fail
  );
};

/** 查看用户浙农码 */
export const getUserZnm = (params,success, fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/manageUser/getZnmCode",
    success,
    fail
  );
};

/** 申请浙农码 */
export const generateZNMCode = (userId = "", success, fail) => {
  return postUrl(
    {
      userId: userId
    },
    "/manager/jxljhs/manageUser/generateZNMCode",
    success,
    fail
  );
};

/** 批量申请浙农码 */
export const batchGenerateZNMCode = (params, success, fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/manageUser/batchGenerateZNMCode",
    success,
    fail
  );
};

/** 同步手机号 */
export const synchPushMobile = (params, success, fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/manageUser/synchPushMobile",
    success,
    fail
  );
};

/** 修改用户状态 */
export const updateUserStatus = (nbr = "", status = "", success, fail) => {
  return postUrl(
    {
      userId: nbr,
      accountNonLocked: status
    },
    "/manager/jxljhs/manageUser/modifyByStatus",
    success,
    fail
  );
};

/** 查询角色列表 */
export const queryRoleListPage = (params, success, fail) => {
  return postUrl(params, "/manager/jxljhs/manageRole/querymore", success, fail);
};

/** 新增角色 */
export const addRole = (params, success, fail) => {
  return postUrl(params, "/manager/role/saveRole", success, fail);
};

/** 角色详情 */
export const roleDetail = (params, success, fail) => {
  return postUrl(params, "/manager/role/getRoleById/", success, fail);
};

/** 修改角色 */
export const updateRole = (params, success, fail) => {
  return postUrl(params, "/manager/role/saveRole", success, fail);
};

/** 删除角色 */
export const deleteRole = (params, success, fail) => {
  return postUrl(params, "/manager/role/deleteRoleById", success, fail);
};

/** 保存角色权限对应关系 */
export const saveRolePermissions = (
  roleId = "",
  resourceIds = "",
  success,
  fail
) => {
  return postUrl(
    {
      roleId: roleId,
      resourceIds: resourceIds
    },
    "/manager/resource/saveRoleResources",
    success,
    fail
  );
};


/** 查询字典类型列表 */
export const queryDictTypeListPage = (
  { name = "", type = "", status = "", pageNum = "", pageSize = "" },
  success,
  fail
) => {
  return postUrl(
    {
      name: name,
      type: type,
      status: status,
      pageNum: pageNum,
      pageSize: pageSize
    },
    "/manager/dictType/queryDictTypeListWithPage",
    success,
    fail
  );
};

/** 新增字典 */
export const addDictType = (
  params,
  success,
  fail
) => {
  return postUrl(
    params,
    "/manager/dictType/saveDictType",
    success,
    fail
  );
};

/** 修改字典 */
export const updateDictType = (
  params,
  success,
  fail
) => {
  return postUrl(
    params,
    "/manager/dictType/saveDictType",
    success,
    fail
  );
};

/** 字典详情 */
export const dictTypeDetail = (id = "", success, fail) => {
  return postUrl(
    {
      id: id
    },
    "/manager/dictType/getDictTypeById",
    success,
    fail
  );
};

/** 删除字典 */
export const deleteDictType = (ids = "", success, fail) => {
  return postUrl(
    {
      dictTypeIds: ids
    },
    "/manager/dictType/deleteDictTypeById",
    success,
    fail
  );
};

/** 查询字典数据列表 */
export const queryDictDataListPage = (
  { dictTypeId = "", dictLabel = "", status = "", pageNum = "", pageSize = "" },
  success,
  fail
) => {
  return postUrl(
    {
      dictTypeId: dictTypeId,
      dictLabel: dictLabel,
      status: status,
      pageNum: pageNum,
      pageSize: pageSize
    },
    "/manager/dictData/queryDictDataListWithPage",
    success,
    fail
  );
};

/** 新增字典数据 */
export const addDictData = (
  dictType = "",
  dictTypeId = "",
  dictLabel = "",
  dictValue = "",
  isDefault = "",
  status = "",
  remark = "",
  success,
  fail
) => {
  return postUrl(
    {
      dictType: dictType,
      dictTypeId: dictTypeId,
      dictLabel: dictLabel,
      dictValue: dictValue,
      isDefault: isDefault,
      status: status,
      remark: remark
    },
    "/manager/dictData/saveDictData",
    success,
    fail
  );
};

/** 字典数据详情 */
export const dictDataDetail = (id = "", success, fail) => {
  return postUrl(
    {
      id: id
    },
    "/manager/dictData/getDictDataById",
    success,
    fail
  );
};

/** 修改字典数据 */
export const updateDictData = (
  id = "",
  dictLabel = "",
  dictValue = "",
  isDefault = "",
  status = "",
  remark = "",
  success,
  fail
) => {
  return postUrl(
    {
      id: id,
      dictLabel: dictLabel,
      dictValue: dictValue,
      isDefault: isDefault,
      status: status,
      remark: remark
    },
    "/manager/dictData/saveDictData",
    success,
    fail
  );
};

/** 删除字典数据 */
export const deleteDictData = (ids = "", success, fail) => {
  return postUrl(
    {
      dictDataIds: ids
    },
    "/manager/dictData/deleteDictDataById",
    success,
    fail
  );
};

/** 查询参数配置列表 */
export const querySysConfigListPage = (
  {
    configName = "",
    configKey = "",
    configType = "",
    pageNum = "",
    pageSize = ""
  },
  success,
  fail
) => {
  return postUrl(
    {
      configName: configName,
      configKey: configKey,
      configType: configType,
      pageNum: pageNum,
      pageSize: pageSize
    },
    "/manager/systemConfig/querySystemConfigListWithPage",
    success,
    fail
  );
};

/** 修改参数配置 */
export const updateSysConfig = (
  id = "",
  name = "",
  key = "",
  value = "",
  type = "",
  remark = "",
  success,
  fail
) => {
  return postUrl(
    {
      id: id,
      configName: name,
      configKey: key,
      configValue: value,
      configType: type,
      remark: remark
    },
    "/manager/systemConfig/saveSystemConfig",
    success,
    fail
  );
};

/** 新增参数配置 */
export const addSysConfig = (params,
  success,
  fail
) => {
  return postUrl(params,
    "/manager/systemConfig/saveSystemConfig",
    success,
    fail
  );
};

/** 参数配置详情 */
export const configDetail = (id = "", success, fail) => {
  return postUrl(
    {
      id: id
    },
    "/manager/systemConfig/getSystemConfigById",
    success,
    fail
  );
};

/** 删除参数配置 */
export const deleteSysConfig = (ids = "", success, fail) => {
  return postUrl(
    {
      systemConfigIds: ids
    },
    "/manager/systemConfig/deleteSystemConfigById",
    success,
    fail
  );
};


/** 通过父节点编号查询子节点机构列表 */
export const queryChildOrganList = (parentNbr = "", success, fail) => {
  return post(
    {
      transcode: "OrganQueryListTrans",
      parentNbr: parentNbr
    },
    success,
    fail
  );
};

/** 机构表格-通过父节点编号查询子节点机构列表 */
export const queryChildOrganListPage = (
  { parentNbr = "", organNbr = "", organName = "", pageNum = 1, pageSize = 10 },
  success,
  fail
) => {
  return post(
    {
      transcode: "OrganQueryListPageTrans",
      parentNbr: parentNbr,
      organNbr: organNbr,
      organName: organName,
      pageNum: pageNum,
      pageSize: pageSize
    },
    success,
    fail
  );
};

/** 新增机构 */
export const addOrgan = (
  parentId = "",
  name = "",
  leader = "",
  phone = "",
  description = "",
  status = "",
  type = "",
  success,
  fail
) => {
  return postUrl(
    {
      // transcode: 'OrganAddTrans',
      parentId: parentId,
      name: name,
      leader: leader,
      phone: phone,
      description: description,
      status: status,
      type: type
    },
    "/manager/auth/addDepartment",
    success,
    fail
  );
};

/** 删除机构 */
export const deleteOrgan = (id = "", success, fail) => {
  return postUrl(
    {
      // transcode: 'OrganDeleteTrans',
      id: id
    },
    "/manager/auth/deleteDepartment",
    success,
    fail
  );
};

/** 查询机构详情 */
export const organDetail = (id = "", success, fail) => {
  return postUrl(
    {
      // transcode: 'OrganQueryDetailTrans',
      id: id
    },
    "/manager/auth/getDepartmentById",
    success,
    fail
  );
};

/** 修改机构 */
export const updateOrgan = (
  id = "",
  name = "",
  leader = "",
  phone = "",
  description = "",
  status = "",
  type = "",
  success,
  fail
) => {
  return postUrl(
    {
      // transcode: 'OrganUpdateTrans',
      id: id,
      name: name,
      leader: leader,
      phone: phone,
      description: description,
      status: status,
      type: type
    },
    "/manager/auth/modifyDepartment",
    success,
    fail
  );
};

/** 新增app版本 */
export const appVersionAdd = (params, success, fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/add",
    success,
    fail
  );
};

/** 修改app版本 */
export const appVersionUpdate = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/modify",
    success,
    fail
  );
};

/** 删除app版本 */
export const appVersionDelete = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/delete",
    success,
    fail
  );
};

/** 查询app版本详情 */
export const appVersionDetail = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/detail",
    success,
    fail
  );
};

/** 查询app版本列表 */
export const appVersionList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/list",
    success,
    fail
  );
};

/** 新增rn版本 */
export const rnVersionAdd = (params, success, fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/rnVersion/add",
    success,
    fail
  );
};

/** 修改rn版本 */
export const rnVersionUpdate = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/rnVersion/modify",
    success,
    fail
  );
};

/** 删除rn版本 */
export const rnVersionDelete = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/rnVersion/delete",
    success,
    fail
  );
};

/** 查询rn版本详情 */
export const rnVersionDetail = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/rnVersion/detail",
    success,
    fail
  );
};

/** 查询rn版本列表 */
export const rnVersionList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/rnVersion/list",
    success,
    fail
  );
};
/** 查询指定更新人员列表 */
export const designatedUserList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/pubc/xcmc/appVersion/designatedUser",
    success,
    fail
  );
};

/** 行业的列表接口 */
export const industryList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/merchantIndustry/industry_multiple_choice",
    success,
    fail
  );
};
/** 评星计划--评价的列表接口 */
export const detaildepictsList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/sys/gradeDetail/choose",
    success,
    fail
  );
};

/** 商户管理--机构列表列表接口 */
export const organRoadList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/organRoad/choose",
    success,
    fail
  );
};


/** APP管理列表 */
export const appMenuList = (params,success,fail) => {
  return postUrl(
    params,
    "/manager/jxljhs/role/detail",
    success,
    fail
  );
};


// WEBPACK FOOTER //
// ./src/api/BaseHttpRequestAPI.js